module.exports = __webpack_public_path__ + "static/media/products-5.886624b7.jpg";